/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_Lead_AfterInputs */

const es_landing_hero_lead_after = /** @type {(inputs: Landing_Hero_Lead_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` hasta 3 meses al año. Zarpar es la plataforma que lo hace posible — y la que menos te cobra.`)
};

const gl_landing_hero_lead_after = /** @type {(inputs: Landing_Hero_Lead_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` ata 3 meses ao ano. Zarpar é a plataforma que o fai posible — e a que menos che cobra.`)
};

const en_landing_hero_lead_after = /** @type {(inputs: Landing_Hero_Lead_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` for up to 3 months a year. Zarpar is the platform that makes it possible — and charges you the least.`)
};

/**
* | output |
* | --- |
* | "for up to 3 months a year. Zarpar is the platform that makes it possible — and charges you the least." |
*
* @param {Landing_Hero_Lead_AfterInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_hero_lead_after = /** @type {((inputs?: Landing_Hero_Lead_AfterInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_Lead_AfterInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_hero_lead_after(inputs)
	if (locale === "en") return en_landing_hero_lead_after(inputs)
	return es_landing_hero_lead_after(inputs)
});